import { render } from "./trend-data.vue?vue&type=template&id=142ff775&scoped=true&ts=true"
import script from "./trend-data.vue?vue&type=script&lang=ts"
export * from "./trend-data.vue?vue&type=script&lang=ts"

import "./trend-data.vue?vue&type=style&index=0&id=142ff775&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142ff775"]])

export default __exports__